import { Button } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";
import styled, { css } from "styled-components";

import { PrintStyleSheet } from "../../../../seller/advert-seller-details/location/location.styles";

export const LeasingTabsPattern = styled.div`
  ${({ theme }) => css`
    color: ${ThemeSelectors.getTitleColor(theme)};

    ul[role="tablist"] {
      padding: 0;
      ${PrintStyleSheet}
    }

    .atc-tab {
      min-width: unset;

      @media (min-width: 350px) {
        min-width: max-content;
      }
    }

    .atc-tab__link {
      font-family: ${ThemeSelectors.getTypeFontName(theme)},
        ${ThemeSelectors.getDefaultTypeStack(theme)};
      color: ${ThemeSelectors.getTitleColor(theme)};
      &:hover {
        cursor: pointer;
      }
    }

    .atc-tab--selected .atc-tab__link {
      color: ${ThemeSelectors.getActionActiveColor(theme)};
    }

    section[role="tabpanel"] {
      margin-top: ${ThemeSelectors.getGroupFiveSpacing(theme)};
      @media print {
        margin-top: 0;
      }
    }

    .ordered {
      margin-top: ${ThemeSelectors.getGroupFiveSpacing(theme)};
    }

    &&& .standard {
      display: block;
    }
  `}
`;

export const LeasingPanelContainer = styled.div`
  @media (min-width: 900px) {
    display: flex;
    flex-direction: column;
    min-height: 265px;
  }
`;

export const LeasingTabsButton = styled(Button)`
  padding: 0;
  text-align: left;
  &:hover:not(:disabled) {
    background: none;
  }
  ${PrintStyleSheet}

  @media (min-width: 900px) {
    margin-top: auto;
  }
`;
